import styled from "styled-components";

export const ReceiveStableCoinWrapper = styled.div`
    width: 100%;
`;

export const ModalTitle = styled.h1`
    font-weight: 500;
    font-family: 'Suisse International';
    color: #000000;
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 32px;
`

export const Error = styled.span`
  color: #f9123b;
  font-family: Inter;
  text-align: right;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15.6px;
`;

export const Container = styled.div`
    width: 100%;
    margin: 32px 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const QrCodeContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 10px 0px #2D42591F;
    padding: 32px;
    background-color: #ffffff;
    border: 1px solid #2D42591F;
    border-radius: 8px;

`;

export const Wrapper = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 7px;
 width: 100%;
`;

export const QrImageWrapper = styled.div`
 display: flex;
 justify-content: center;
 align-items: center;
 line-height: 0;
`;

export const Address = styled.p`
 margin: 0;
 max-width: 50%;
 text-align: center;
 font-family: "Inter", sans-serif;
 font-size: 14px;
 font-weight: 400;
 line-height: 20px;
 color: #000000;

 @media (max-width: 768px) {
    max-width: 100%;
 }
`;

export const CopyButton = styled.button`
 display: inline-flex;
 align-items: center;
 justify-content: center;
 gap: 6px;
 margin-top: 8px;
 padding: 8px 16px;
 border: 1px solid #1A1A1A;
 border-radius: 8px;
 background: #ffffff;
 cursor: pointer;

 span {
   font-family: "Inter", sans-serif;
   font-size: 12px;
   font-weight: 600;
   line-height: 16px;
   color: #000000;
 }

 svg {
   width: 16px;
   height: 16px;
 }

 &:hover {
   background: #fcfcfc;
 }
`;

export const FooterText = styled.p`
 font-family: "Suisse International";
 font-size: 12px;
 font-weight: 400;
 line-height: 16px;
 color: #000000;
 text-align: center;

 span {
    font-weight: 700;

 }
`;

export const ButtonContainer = styled.div`
 display: flex;
 justify-content: center;
 align-items: center;
 gap: 8px;
 width: 100%;
`;
